import { SVGProps } from 'react'

export const ZHIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}
  >
    <rect width="48" height="48" fill="#DE2910" />

    <polygon
      fill="#FFDE00"
      points="10,6 11.6,10.6 16.6,10.6 12.6,13.6 14.2,18.2 10,15.2 5.8,18.2 7.4,13.6 3.4,10.6 8.4,10.6"
    />

    <polygon
      fill="#FFDE00"
      points="20,4 21,6 23,6 21.4,7.2 22.2,9.2 20,8 17.8,9.2 18.6,7.2 17,6 19,6"
    />
    <polygon
      fill="#FFDE00"
      points="24,8 25,10 27,10 25.4,11.2 26.2,13.2 24,12 21.8,13.2 22.6,11.2 21,10 23,10"
    />
    <polygon
      fill="#FFDE00"
      points="24,14 25,16 27,16 25.4,17.2 26.2,19.2 24,18 21.8,19.2 22.6,17.2 21,16 23,16"
    />
    <polygon
      fill="#FFDE00"
      points="20,18 21,20 23,20 21.4,21.2 22.2,23.2 20,22 17.8,23.2 18.6,21.2 17,20 19,20"
    />
  </svg>
)
